import React from "react";
import { NavHashLink } from "react-router-hash-link";
import { Link } from "react-router-dom";

const ProjectDetails = () => {
	return (
		<div className="container-fluid bg-dark-theme py-5 py-md-7" id="sticky">
			<div className="container px-0">
				<div className="grid">
					<div className="d-none d-md-block stay">
						<NavHashLink
							smooth
							to="#project-details"
							activeClassName="active"
							className="button-special mb-3 btn w-100 rounded"
						>
							Project Details
						</NavHashLink>
						<NavHashLink smooth to="#introduction" activeClassName="active" className="button-special mb-3 btn w-100 rounded">
							Introduction
						</NavHashLink>
						<NavHashLink smooth to="#challenge" activeClassName="active" className="button-special mb-3 btn w-100 rounded">
							The Challenge
						</NavHashLink>
						<NavHashLink smooth to="#audience" activeClassName="active" className="button-special mb-3 btn w-100 rounded">
							Defining The Audience
						</NavHashLink>
						<NavHashLink smooth to="#research" activeClassName="active" className="button-special mb-3 btn w-100 rounded">
							Research
						</NavHashLink>
						<NavHashLink
							smooth
							to="#visual-direction"
							activeClassName="active"
							className="button-special mb-3 btn w-100 rounded"
						>
							Visual Direction
						</NavHashLink>
						<NavHashLink smooth to="#testing" activeClassName="active" className="button-special mb-3 btn w-100 rounded">
							Testing
						</NavHashLink>
						<NavHashLink smooth to="#current-stride" activeClassName="active" className="button-special mb-3 btn w-100 rounded">
							Achievements
						</NavHashLink>
					</div>
					<div className="text-white sectns">
						<div className="d-flex border-bottom py-1" id="project-details">
							<div className="col-4 col-md-3">
								<p className="font-weight-bold mb-0">Client</p>
							</div>
							<div className="col-8 col-md-9">
								<p className="mb-0">SogoVR</p>
							</div>
						</div>
						<div className="d-flex border-bottom py-1">
							<div className="col-4 col-md-3">
								<p className="font-weight-bold mb-0">Sector</p>
							</div>
							<div className="col-8 col-md-9">
								<p className="mb-0">Entertainment</p>
							</div>
						</div>
						<div className="d-flex border-bottom py-1">
							<div className="col-4 col-md-3">
								<p className="font-weight-bold mb-0">My Role</p>
							</div>
							<div className="col-8 col-md-9">
								<p className="mb-0">
									Creating a seamless user experience, engaging interface, and a sense of Authenticity and simplicity in
									the tone of voice of the product
								</p>
							</div>
						</div>
						<div className="d-flex border-bottom py-1">
							<div className="col-4 col-md-3">
								<p className="font-weight-bold mb-0">Project Time</p>
							</div>
							<div className="col-8 col-md-9">
								<p className="mb-0">4 Months</p>
							</div>
						</div>

						<div className="details" id="introduction">
							<div className="mb-bottom">
								<h3 className="font-weight-bold mb-3">Introduction</h3>
								<p>
									Virtual Reality (VR) gives a transformed visualization of the environments around us. It creates an
									impressive, immersive experience that goes far beyond anything that can be achieved with physical or
									Video Musical events/meetings.
								</p>
							</div>
							<div className="mb-bottom">
								<h3 className="font-weight-bold mb-3">About SogoVR</h3>
								<p>
									SogoVR is a Virtual Reality Application for various Entertainment immersive projects that brings the
									music of the greatest composers/Artistes to the public streaming Via the Virtual Reality Environment.
									Users can have Roam around Entertainment events centers ranging from concerts to orchestra to witness
									the look and feel of the events. SogoVR have pride themselves in delivering this experience to a
									selection of Music Composers and Performers over the next couple of years.
								</p>
							</div>
							<div className="mb-bottom">
								<h3 className="font-weight-bold mb-3" id="challenge">
									The Challenge
								</h3>
								<img
									className="object-fit-cover w-100 w-100"
									src="/assets/challenge.png"
									alt="The Challenge"
									loading="lazy"
								/>
							</div>
							<div className="mb-bottom">
								<h3 className="font-weight-bold mb-4">Product Goals</h3>
								<div className="mb-4">
									<h6 className="font-weight-bold">Simplicity</h6>
									<p>
										Offer ease of Use with simple user interface and pin point preferences by which users can use
										various filter Options
									</p>
								</div>
								<div className="mb-4">
									<h6 className="font-weight-bold">Immersive Experience</h6>
									<p>
										Exclusive Access to Nigerian and African content globally, for patrons all over the world from the
										comfort of their mobile devices with multiple viewpoints available (Backstage, Front of Stage
										etc...)
									</p>
								</div>
								<div className="mb-4">
									<h6 className="font-weight-bold">Affordable</h6>
									<p>Price Flexibility, flexible E-Ticket prices, affordable for anyone and everyone</p>
								</div>
								<div className="mb-4">
									<h6 className="font-weight-bold">Multidevice</h6>
									<p>
										Safer Product with the lenses on the VR Glasses we produce, specially made to protect the eyes from
										UV lights from mobile phones, unlike any of its competitors.
									</p>
								</div>
							</div>
							<div className="mb-bottom">
								<h3 className="font-weight-bold mb-4" id="audience">
									Defining The Audience
								</h3>
								<p className="font-weight-bold">The product audience is divided into two main groups:</p>
								<ul>
									<li className="mb-3">Artists/Musicians</li>
									<li className="mb-3">Entertainment Lover(s) / Fan(s)</li>
								</ul>
								<p className="mt-3">
									The target audience for SogoVR from the research, User Categories were estimated to be:
								</p>
								<img
									className="object-fit-cover w-100"
									src="/assets/define-audience.png"
									alt="Defining the audience"
									loading="lazy"
								/>
							</div>
							<div className="mb-bottom">
								<h3 className="font-weight-bold mb-4">Building Empathy</h3>
								<div className="mb-4">
									<h6 className="font-weight-bold">Persona</h6>
									<p>
										For early-stage iteration, the focus group had to major User types: Users who are Unable to attend
										and Users who were willing to test out he technological capacity of VR in live event streaming,
										Using the user profiles I created a user persona. The persona below, borne out of user research
										helped keep the design process user-centered:
									</p>
								</div>
								<img className="object-fit-cover w-100 mb-4" src="/assets/persona1.png" alt="Persona" loading="lazy" />
								<img className="object-fit-cover w-100 mb-4" src="/assets/persona2.png" alt="Persona" loading="lazy" />
								<img className="object-fit-cover w-100 mb-4" src="/assets/persona3.png" alt="Persona" loading="lazy" />
							</div>
							<div className="mb-bottom">
								<h3 className="font-weight-bold my-4">UX Process</h3>
								<p className="mb-3">
									For the project the Double Diamond design model which has four stages: (Discovery, Definition,
									Development and Delivery) was used to help iterate the product from design to first MVP stage.
								</p>
								<img
									className="object-fit-cover w-100"
									src="/assets/design-principle.png"
									alt="Design Principle"
									loading="lazy"
								/>
							</div>
							<div className="mb-bottom" id="research">
								<h3 className="font-weight-bold mb-4">Research direction</h3>
								<ul>
									<li className="mb-3">Exploring technological integration in the entertainment industry.</li>
									<li className="mb-3">Immersive and innovative experience.</li>
									<li className="mb-3">Freedom of choice around time and experience.</li>
									<li className="mb-3">Accessible accessories such as VR headsets.</li>
									<li className="mb-3">Simplifying the event booking process.</li>
								</ul>

								<img className="object-fit-cover w-100" src="/assets/info.png" alt="Request" loading="lazy" />
							</div>
							<div className="mb-bottom">
								<h3 className="font-weight-bold mb-4">User Needs</h3>
								<p className="mb-3">While going through the Onboarding process, this is the usual context for users:</p>
								<ul>
									<li className="mb-3">I don't want to miss an event or musical concert</li>
									<li className="mb-3">I don't want to travel long distance to concert venue</li>
									<li className="mb-3">When does the event happen</li>
								</ul>
							</div>
							<div className="mb-bottom">
								<h3 className="font-weight-bold mb-4">The Solution</h3>
								<p className="mb-3">
									Developing a platform that gives people access to more immersive experiences of African content; the
									most anticipated live and playback events around the world.
								</p>
								<img className="object-fit-cover w-100" src="/assets/solution.png" alt="The Solution" loading="lazy" />
							</div>
							<div className="mb-bottom">
								<h3 className="font-weight-bold mb-4">Information Architecture</h3>
								<p className="mb-3">
									Developing a user path is very important in creating structured, organized, effective and sustainable
									way.
								</p>
								<img
									className="object-fit-cover w-100"
									src="/assets/it-arch.png"
									alt="Information Architecture"
									loading="lazy"
								/>
							</div>
							<div className="mb-bottom" id="visual-direction">
								<h3 className="font-weight-bold mb-4">Visual Designs</h3>
								<p className="mb-3">
									The visual design was developed by iterating from mood boards and styletiles to the UI kit and finally
									to creating a first version of the style guide.
								</p>
								<div>
									<h6 className="font-weight-bold mt-top mb-4">Style Guide</h6>
									<p className="mb-3">
										A style guide was created to establish a standard style requirements to improve communication by
										ensuring consistency both within all documents, and across other multiple documents. Elements
										includes Reuseable UI components, identifiable colors, clear and accesible CTAs, etc. A Typography
										style that offers simplicity, readability and clarity of message was chosen for this project
									</p>
									<img
										className="object-fit-cover w-100"
										src="/assets/visual-designs.png"
										alt="Visual Designs"
										loading="lazy"
									/>
								</div>
								<div className="mt-top">
									<h6 className="font-weight-bold mb-4">Onboarding</h6>
									<p className="mb-3">
										To help users ease into the product’s experience, I designed an onboarding screen with series of
										interactions and/instructions providing the potential product users with an on-ramp to the benefits
										of the product, while also giving carefully guided instruction to help them set up sucessfully.
									</p>
									<img className="object-fit-cover w-100" src="/assets/onboarding.png" alt="Onboarding" loading="lazy" />
								</div>
								<div className="mt-top">
									<h6 className="font-weight-bold mb-4">Registration</h6>
									<p className="mb-3">
										A registration screen with basic user details needed for authentication into the App event page was
										designed, Easy social login options were provided to help new users use the quick options.
									</p>
									<img
										className="object-fit-cover w-100"
										src="/assets/registration.png"
										alt="Registration"
										loading="lazy"
									/>
								</div>
								<div className="mt-top">
									<h6 className="font-weight-bold mb-4">Event search/booking</h6>
									<p className="mb-3">
										To help user access events faster and more accurately , A Home page with simplified and easily
										accessible search section and filters was designed, Users can also select and make choices based on
										featured events and suggestions.
									</p>
									<img
										className="object-fit-cover w-100"
										src="/assets/event-search.png"
										alt="Event search/booking"
										loading="lazy"
									/>
								</div>
								<div className="mb-bottom mt-top">
									<h3 className="font-weight-bold mb-4">VR Environment</h3>
									<img className="object-fit-cover w-100" src="/assets/vr.png" alt="VR Environment" loading="lazy" />
								</div>
								<div className="mt-top">
									<h6 className="font-weight-bold mb-4">Controls</h6>
									<p className="mb-3">
										SogoVR users access control to the App through basic Navigation's system and require the in built
										function of the VR headsets for it VR Environment controls. VR Headset controls on the app are
										limited to Movement Pause Play and Exit Environment Options
									</p>
									<img className="object-fit-cover w-100" src="/assets/controls.png" alt="Controls" loading="lazy" />
								</div>
							</div>
							<div className="mb-bottom" id="testing">
								<h3 className="font-weight-bold mb-4">A/B Testing</h3>
								<p className="mb-3">
									To quantitatively review the usability assumptions, I did A/B and click tests, which confirmed my
									assumptions except for a few details. First and foremost, I tested the navigation structure , the
									wording of some actions as well as preferences regarding the visual design.
								</p>
								<img className="object-fit-cover w-100" src="/assets/testing.png" alt="A/B Testing" loading="lazy" />
							</div>
							<div className="mb-bottom">
								<h3 className="font-weight-bold mb-4">What's Next?</h3>
								<p className="mb-3">
									Carrying out further research and testing of the existing product, as with any project, testing is
									essential. But especially with The More Aged Audience, because The Age Gap effect involved in
									Transitioning from Physical into a more advance technology approach needs be addressed so this would be
									quite an interesting Information to work on while this will also serve as the perfect opportunity to
									validate the usability of the design.
								</p>
							</div>
							<div className="mb-bottom" id="current-stride">
								<h3 className="font-weight-bold mb-4">Current Strides</h3>
								<p className="mb-3">The Wonderland Experience</p>
								<img
									className="object-fit-cover w-100 mb-3"
									src="/assets/strides.png"
									alt="Current Strides"
									loading="lazy"
								/>
								<p className="mb-3">
									Working with Teni Entertainment Group (Teni) SogoVR produced an experience that puts you in the middle
									of a Musical/ Entertainment session in the Production of the Wondaland Experience series.
								</p>
								<div className="my-4">
									<p className="mb-3">Brand: Teni Entertiner</p>
									<p className="mb-3">Client: Teni</p>
									<p className="mb-3">Deliverables: Web VR Player</p>
								</div>
							</div>
							<div className="mb-bottom">
								<h3 className="font-weight-bold mb-4">General VR Experience</h3>
								<div className="wrapper">
									<div className="h-frame">
										<iframe
											width="560"
											height="315"
											src="https://www.youtube.com/embed/zPhVLxqzTlk"
											title="YouTube video player"
											frameborder="0"
											allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
											allowfullscreen
										></iframe>
									</div>
								</div>
							</div>
							<div className="mb-bottom">
								<h3 className="font-weight-bold mb-4">Conclusion</h3>
								<p className="mb-3">
									With Virtual reality growing tremendously at a fast pace, new opportunities and possibilities are
									opening up everyday. This product works with the simple mission of connecting people to their
									entertainment passion by simplifying the process,thus bringing it closer to their homes in an affordable
									and most importantly accesible way.{" "}
								</p>
							</div>
							<div className="d-flex justify-content-between align-items-center links">
								<Link className="text-white" to="/work/sogovr">
									&lt;&lt; Previous <span className="d-none d-md-inline">Case Study</span>
								</Link>
								<Link className="text-white" to="/work/sogovr">
									Next <span className="d-none d-md-inline">Case Study</span>&gt;&gt;
								</Link>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default ProjectDetails;
